import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './utils/leafletConfig';
import Router from './router/Router';
import 'mdb-react-ui-kit/dist/css/mdb.min.css';
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./shards-dashboard/styles/shards-dashboards.1.1.0.min.css";
import "./styles/theme.css";

import './i18n'
import { getInitialTheme, applyThemeAttribute } from './utils/theme';
import AppThemeProvider from './components/common/AppThemeProvider';

// Applied synchronously before the first paint so the saved/system theme
// preference never flashes light-then-dark on load.
applyThemeAttribute(getInitialTheme());

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AppThemeProvider>
      <Router />
    </AppThemeProvider>
  </React.StrictMode>
);
